import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	title: {
		id: 'company-hub.knowledge-cards-extension.extension-title',
		defaultMessage: 'Knowledge Cards',
		description:
			'Title of knowledge cards extension to be displayed in toolbar/shortcut macros dropdown.',
	},
	description: {
		id: 'company-hub.knowledge-cards-extension.extension-description',
		defaultMessage: 'Description of knowledge cards (update me)',
		description:
			'Description of knowledge cards extension to be displayed in toolbar/shortcut macros dropdown',
	},
});
